import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/** @jsx jsx */
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { jsx } from '@emotion/react';
import { fullPageEditorWrapper } from './StyledComponents';
import { ContextPanelWidthProvider } from '@atlaskit/editor-common/ui';
import { FullPageContentArea } from './FullPageContentArea';
import { FullPageToolbar } from './FullPageToolbar';
import { browser } from '@atlaskit/editor-common/utils';
var useShowKeyline = function useShowKeyline(contentAreaRef) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showKeyline = _useState2[0],
    setShowKeyline = _useState2[1];
  useEffect(function () {
    var _contentAreaRef$curre;
    if (!((_contentAreaRef$curre = contentAreaRef.current) !== null && _contentAreaRef$curre !== void 0 && _contentAreaRef$curre.contentArea)) {
      return;
    }
    var intersection = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
    }, {
      root: undefined,
      // Safari seems to miss events (on fast scroll) sometimes due
      // to differences in IntersectionObserver behaviour between browsers.
      // By lowering the threshold a little it gives Safari more
      // time to catch these events.
      threshold: browser.safari ? 0.98 : 1
    });
    intersection.observe(contentAreaRef.current.contentArea);
    return function () {
      intersection.disconnect();
    };
  }, [contentAreaRef]);
  return showKeyline;
};
export var FullPageEditor = function FullPageEditor(props) {
  var _scrollContentContain, _scrollContentContain2, _wrapperElementRef$cu;
  var wrapperElementRef = useMemo(function () {
    return props.innerRef;
  }, [props.innerRef]);
  var scrollContentContainerRef = useRef(null);
  var showKeyline = useShowKeyline(scrollContentContainerRef);
  return jsx(ContextPanelWidthProvider, null, jsx("div", {
    css: fullPageEditorWrapper,
    className: "akEditor",
    ref: wrapperElementRef
  }, jsx(FullPageToolbar, {
    appearance: props.appearance,
    beforeIcon: props.primaryToolbarIconBefore,
    collabEdit: props.collabEdit,
    containerElement: (_scrollContentContain = (_scrollContentContain2 = scrollContentContainerRef.current) === null || _scrollContentContain2 === void 0 ? void 0 : _scrollContentContain2.scrollContainer) !== null && _scrollContentContain !== void 0 ? _scrollContentContain : null,
    customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
    disabled: !!props.disabled,
    dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
    editorActions: props.editorActions,
    editorDOMElement: props.editorDOMElement,
    editorView: props.editorView,
    eventDispatcher: props.eventDispatcher,
    hasMinWidth: props.enableToolbarMinWidth,
    popupsBoundariesElement: props.popupsBoundariesElement,
    popupsMountPoint: props.popupsMountPoint,
    popupsScrollableElement: props.popupsScrollableElement,
    primaryToolbarComponents: props.primaryToolbarComponents,
    providerFactory: props.providerFactory,
    showKeyline: showKeyline,
    featureFlags: props.featureFlags
  }), jsx(FullPageContentArea, {
    ref: scrollContentContainerRef,
    appearance: props.appearance,
    contentComponents: props.contentComponents,
    contextPanel: props.contextPanel,
    customContentComponents: props.customContentComponents,
    disabled: props.disabled,
    dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
    editorActions: props.editorActions,
    editorDOMElement: props.editorDOMElement,
    editorView: props.editorView,
    eventDispatcher: props.eventDispatcher,
    popupsBoundariesElement: props.popupsBoundariesElement,
    popupsMountPoint: props.popupsMountPoint,
    popupsScrollableElement: props.popupsScrollableElement,
    providerFactory: props.providerFactory,
    wrapperElement: (_wrapperElementRef$cu = wrapperElementRef === null || wrapperElementRef === void 0 ? void 0 : wrapperElementRef.current) !== null && _wrapperElementRef$cu !== void 0 ? _wrapperElementRef$cu : null,
    pluginHooks: props.pluginHooks,
    featureFlags: props.featureFlags
  })));
};